import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ServerAction, ServerTranslator } from '@cbridge-packages/server';

type IDependencies = IClientApiDependencySegment;

export const loadServerEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ServerAction.load.started),
  mergeMap((params) => {
    return dependencies.api.getServerDetails(params).pipe(
      mergeMap((response) => {
        return [
          ServerAction.load.done({
            params,
            result: ServerTranslator.fromApiDetails(params.serverId, response),
          }),
        ];
      }),
      catchApiError((error) => {
        return [
          ServerAction.load.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
